const OPEN_SO = new Set(["Pending", "Confirmed"]);
const CLOSED_PO = new Set(["Completed", "Cancelled"]);

const sumBy = (list, keyFn, valFn) => list.reduce((acc, x) => { const k = keyFn(x); if (k) acc[k] = (acc[k] || 0) + valFn(x); return acc; }, {});

// Finished goods = manufactured, not archived, and either not used as a component of another
// item OR having open sales-order demand (demandIds) so items also used in other BOMs still surface.
export function finishedGoods(bomItems = [], demandIds = new Set()) {
  const componentIds = new Set(bomItems.flatMap((b) => (b.components || []).map((c) => c.item_id)));
  return bomItems.filter(
    (b) =>
      b.item_type === "manufactured" &&
      b.status !== "archived" &&
      (!componentIds.has(b.id) || demandIds.has(b.id)),
  );
}

// Per finished good: open sales demand − warehouse stock − qty already in open production orders.
export function planningRows(salesOrders = [], bomItems = [], orders = []) {
  const soItems = salesOrders.filter((so) => OPEN_SO.has(so.status)).flatMap((so) => so.items || []);
  const demand = sumBy(soItems, (it) => it.item_id, (it) => Number(it.quantity || 0));
  const demandIds = new Set(Object.keys(demand).filter((id) => demand[id] > 0));
  const inProduction = sumBy(
    orders.filter((o) => o.bom_item_id && !CLOSED_PO.has(o.status)),
    (o) => o.bom_item_id,
    (o) => Math.max(0, Number(o.target_quantity || 0) - Number(o.produced_quantity || 0)),
  );
  return finishedGoods(bomItems, demandIds)
    .map((fg) => {
      const pending = demand[fg.id] || 0;
      const stock = Number(fg.stock_quantity || 0);
      const reserved = Number(fg.so_reserved || 0);
      const available = Math.max(0, stock - reserved); // available to plan = on-hand − reserved for confirmed orders
      const wip = inProduction[fg.id] || 0;
      return { ...fg, pending_demand: pending, reserved, available_stock: available, in_production: wip, need_to_produce: Math.max(0, pending - available - wip) };
    })
    .filter((r) => r.need_to_produce > 0)
    .sort((a, b) => b.need_to_produce - a.need_to_produce);
}
